"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var Icon_1 = require("../../Icon");
var stylesImport = require("./Check.scss");
var styles = stylesImport;
var Check = (function (_super) {
    tslib_1.__extends(Check, _super);
    function Check() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Check.prototype.shouldComponentUpdate = function (newProps) {
        return this.props.isChecked !== newProps.isChecked || this.props.checked !== newProps.checked;
    };
    Check.prototype.render = function () {
        var _a = this.props, isChecked = _a.isChecked, checked = _a.checked;
        isChecked = isChecked || checked;
        return (React.createElement("div", { className: Utilities_1.css('ms-Check', styles.root, (_b = {},
                _b["is-checked " + styles.rootIsChecked] = isChecked,
                _b)) },
            Icon_1.Icon({
                className: 'ms-Check-circle ' + styles.circle,
                iconName: 'CircleRing'
            }),
            Icon_1.Icon({
                className: 'ms-Check-check ' + styles.check,
                iconName: 'StatusCircleCheckmark'
            })));
        var _b;
    };
    Check.defaultProps = {
        isChecked: false
    };
    return Check;
}(Utilities_1.BaseComponent));
exports.Check = Check;
//# sourceMappingURL=Check.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Check/Check.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Check/Check.js
// module chunks = 1